import { _,$,Backbone,Foundation, moment } from '../../vendor'
import InboomaBaseController from './InboomaBaseController'
import Order from '../models/Order'

import linksMap from './OrdersControllerAccessBarMap'
import ReservationsSidebarView from '../views/reservationsList/ReservationsSidebarView'
import ReservationsSortTabs from '../views/reservationsList/ReservationsSortTabs'
import OffCanvasOrdersForm from '../views/orders/OffCanvasOrdersForm'
import ReservationsView from '../views/reservationsList/ReservationsView'

import ReservationsTpl from '../templates/reservationsList/ReservationsTpl.html'

import OffCanvasAddPayment from '../views/orders/OffCanvasAddPayment';
import Reservation from '../models/Reservation';
import ReservationsList from '../collections/ReservationsList';         // complete collection of reservations with proxy and filter
import CheckinOutView from '../views/orders/CheckinOut';
import QuickOrderForm from '../views/orders/QuickOrderForm';
import { isViewVisible} from '../utils/ViewSettings';
import { Uri } from '../utils';

export default InboomaBaseController.extend({

    _channelName: 'reservationsList',
    _el: '#inb-c-main-orders',
    _template: ReservationsTpl,
    _filterSidebar : {},            // used to restore filter settings after opening off canvas forms
    _canvasToOpen : {
        source: null,                 // return to source canvas (if set) after closing destination canvas
        destination: null             // open destination canvas if set (e.g. open 'addpayment' after closing 'edit')
    },
    _pendingCollectionUpdate : false,

    _accessBarMap () {
        return {
            model: Reservation,
            collection: this._collection,
            pageTitle: this.t('reservations',null,'capital'),
            searchPlaceholder: this.t('order_nbr'),
            linksMap: linksMap()
        }
    },

    _shouldRenderLayout () {
        const isSelf = document.querySelector('.help-link');
        return (isSelf === null || isSelf.getAttribute('href') !== '/reservationsList/help');
    },

    /*
      this is called by sidebar view if settings have changed
    */
    storeFilterSettingsOfCollection (sidebarView,filterSettings) {

        let defaultDateCondition = false,
            dateConditionExists = false,
            defaultReservationStatus = false,
            reservationStatusExists = false;

        filterSettings.forEach((item) => {
            if (item.type === 'date-condition') {
                dateConditionExists = true;
            }
            if (item.type === 'reservation-status') {
                reservationStatusExists = true;
            }
        });

        if (dateConditionExists === false) {
            defaultDateCondition = {
                filter : "upcoming",
                type : "date-condition",
                value : moment().format('YYYY-MM-DD H:mm:ss')
            };
            //filterSettings.push(defaultDateCondition);
        }
        if (reservationStatusExists === false) {
            defaultReservationStatus = {
                filter : "reset",
                type : "reservation-status",
                value : "reset"
            };
            //filterSettings.push(defaultDateCondition);
        }

        this._filterSidebar = {
          'sidebarView' : sidebarView,
          'filterSettings' : filterSettings
        };
    },

    // @todo Better use directly this._collection.getFilters();
    getStoredFilterSettingsOfCollection () {
        if (typeof this._filterSidebar.filterSettings != 'undefined') {
            return this._filterSidebar.filterSettings;
        }
        else {
            return [];
        }
    },

    setCanvasToOpen (source,destination) {
        this._canvasToOpen = {source, destination};
    },
    
    /** 
     * @routes /reservationsList
     */
    index (options = null) {

        if (isViewVisible('reservationsList') !== true) {
          Backbone.history.navigate('orders',{trigger:true});
        }

        if (typeof this.accessBar !== 'undefined') this.accessBar.changeActiveLink('reservationsList');

        this._updateCollection();

        this._resetOptions(options);

        if (!this._shouldRenderLayout()) {
            this._processOpenCanvasQueue();
            return;
        }

        if (typeof this.reservationsListView !== 'undefined' && this.reservationsListView != null) {   // prevent view and all child views stucking in memory
          this.reservationsListView.removeEventListener();
          this.reservationsListView.remove();
        }

        this.reservationsListView = new ReservationsView({
            collection: this._collection,
            widgetMode: document.location.href.indexOf('dashboard') < 0 ? false : true,
            el: this.el === undefined ? document.getElementById('inb-c-main-orders') : this.el,
            toggleId: this.options
        });

        if (document.location.href.indexOf('dashboard') < 0) {
            // always load stored filter settings into side bar (is empty when reservations list has been reloaded)

            if (Uri.getUrlParameter('resource_id')) {

              // initialize collection with filter for resource id
              delete this._collection._filterParams['begin_gte'];
              this._collection._filterParams['resource_id'] = Uri.getUrlParameter('resource_id');
              this._collection.setSort("begin","desc",true);
            }

            this.reservationsSortTabs = new ReservationsSortTabs({ collection: this._collection, model: Reservation});
            this.reservationsSidebarView = new ReservationsSidebarView({ collection: this._collection, model: Reservation, controller: this});
        }

        this._processOpenCanvasQueue();
    },

    /**
     * @routes /reservationsList/help
     */
    reservationsListHelp () {

        //this.index();

        new Foundation.Reveal($('.inb-orders-help-modal')).open();

        $('.inb-orders-help-modal').on('closed.zf.reveal', function() {
            Backbone.history.navigate('reservationsList');
            $('.inb-orders-help-modal').off('closed.zf.reveal');
        });
    },

    _editReservation (orderId, reservationId) {

      const that = this,
            RequestHelper = Backbone.Model.extend({ urlRoot : '/orders' });

      // get order by id and open as offCanvasOrdersForm
      // === Orders.fetchById
      // @todo w u not use native /orders/[ID]/edit?
      // @duplicate ?
      (new RequestHelper({ id: orderId })).fetch({
            success (model, response) {

                let _model = new Order();

                _.extend(_model.attributes,model.attributes.data);                  // copy data of model

                _model.attributes.reservations = new ReservationsList();            // reservations attribute must be a collection
                _.each(model.attributes.data.reservations, function(res) {
                  _model.attributes.reservations.add(res);
                });

                const offCanvasOrdersForm = new OffCanvasOrdersForm({
                  model: _.clone(_model),
                  toggleAddReservation: false,
                  toggleReservation: reservationId,
                  reservationId,
                  collection: that._collection,
                  context: 'reservations/reservationsList',
                  controller: that
                });
            },
            error (model, response) {
                console.log("Error, could not request order.");
            }
          });

    },

    _addpaymentByOrder (id,context) {

      const that = this,
            RequestHelper = Backbone.Model.extend({ urlRoot : '/orders' });

      return new Promise(
        (resolve, reject) => {

          (new RequestHelper()).save(
              {
                id : id,
              },{
                type: 'GET',
                success (model, response) {

                  let _model = new Order();

                  _.extend(_model.attributes,model.attributes.data);                  // copy data of model

                  _model.attributes.reservations = new ReservationsList();            // reservations attribute must be a collection
                  _.each(model.attributes.data.reservations, function(res) {
                    _model.attributes.reservations.add(res);
                  });
                    _model.id = id;

                    const offCanvasAddPaymentForm = new OffCanvasAddPayment({
                    model: _.clone(_model),
                    toggleAddReservation: false,
                    toggleReservation: null,
                    collection: that._collection,
                    context: context
                  });
                  resolve();
                },
                error (model, response) {
                  console.log("Error, could not request order.");
                  reject();
                }
              });
          }
      );
    },


    /**
     * @routes /orders/:orderId[int]/payment
     */
    paymentList(orderId) {

        this.index();

        const model = this._collection.get(orderId);

        const offCanvasOrdersForm = new OffCanvasOrdersForm ({
            model,
            collection: this._collection
        });

    },

    /**
     * @routes /reservationsList/:reservationId/:action
     */
    reservationsForm (reservationId, action, canvas) {

        this.index();

        const that = this;
        const reservation = this._collection.get(reservationId);

        const workReservationsForm = (orderId) => {

          if (typeof orderId == 'undefined') {
            return;
          }

          if (action == 'edit') {
            this._editReservation(orderId,reservationId);
          }

          if (action == 'addpayment') {

            if (typeof canvas == 'object' && canvas != null && typeof canvas.close == 'function') {
              canvas.close();
            }
            this._addpaymentByOrder(orderId,'reservations/reservationsList');        // orderId, context for backward navigation from orders form
          }

          if (action == 'checkin') {

            const checkinout = new CheckinOutView({
              model : this._collection.get(reservationId)
            });
          }
        }

        if (reservation !== undefined && reservation != null) {
          workReservationsForm(reservation.get('order_id'));
          return;
        }

        const RequestHelper = Backbone.Model.extend({ urlRoot : '/reservations/' + reservationId });

        (new RequestHelper()).fetch({
          success (model, response) {
            // get order id
            if (response.data.order_id !== undefined) workReservationsForm(response.data.order_id);
          },
          error (model, response) {
            console.log("ERROR when fetching reservation");
          }
        });    
    },

    ordersAdd () {

      const quickOrderForm = new QuickOrderForm();
    }
   
});
